import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControl, Grid, Input, InputAdornment, InputLabel, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format } from 'date-fns';
import { LoadingButton } from '@mui/lab';
// import { CustomDescrypt } from '../../../../../../utils/MyEncryption';
// import { AuthStore } from '../../../../../../store/UserStore';
// import { base_url } from '../../../../../../utils/GlobalVariables';
import axios from 'axios';
import Swal from 'sweetalert2';
import { AttachFile, ExpandMore, Save } from '@mui/icons-material';
import { CustomDescrypt } from '../../../../../utils/MyEncryption';
import { AuthStore } from '../../../../../store/UserStore';
import { base_url } from '../../../../../utils/GlobalVariables';
import { updateFirebasePermintaan } from '../../../../../utils/Firebase';

const FormGaji = ({ pencairan }) => {
    const { setBreadcrumbItem } = useOutletContext();
    const navigate = useNavigate();
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [loading, setLoading] = useState(false);
    const logOut = AuthStore((state) => state.logOut);
    const [formData, setFormData] = useState({
        // _method: null,
        tgl_spm: "",
        no_spm: "",
        no_spp: "",
        jenis: "LS",
        jenis_ls: "Gaji",
        keperluan: "",
        anggaran: "",
        file_spm: "",
        file_daftar_gaji: "",
        revisi: null
        // progres: ""
    });
    const [src, setSrc] = useState("");
    const [srcDaftarGaji, setSrcDaftarGaji] = useState("");

    useEffect(() => {
        setBreadcrumbItem({ '/bnd': 'Home', '/bnd/pencairan': 'SPM', '': pencairan === null ? 'Tambah (LS Gaji)' : 'Edit (LS Gaji)' });
        console.log(pencairan);

        if (pencairan !== null) {
            setFormData({
                _method: 'PUT',
                tgl_spm: pencairan.tgl_spm,
                no_spm: pencairan.no_spm,
                no_spp: pencairan.no_spp,
                jenis: pencairan.jenis,
                jenis_ls: pencairan.jenis_ls,
                keperluan: pencairan.keperluan,
                anggaran: rP(pencairan.anggaran),
                file_spm: "",
                file_daftar_gaji: "",
                revisi: pencairan.revisi,
                progres: pencairan.progres,
                kontrak: pencairan.kontrak
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        pencairan === null ?
            formData.file_spm === "" ?
                setSrc("")
                :
                setSrc(URL.createObjectURL(formData.file_spm))
            :
            formData.file_spm === "" ?
                setSrc(base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + decryptedUser.id_opd + '/' + pencairan.jenis + '/spm/' + pencairan.file)
                :
                setSrc(URL.createObjectURL(formData.file_spm))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.file_spm])

    useEffect(() => {
        pencairan === null ?
            formData.file_daftar_gaji === "" ?
                setSrcDaftarGaji("")
                :
                setSrcDaftarGaji(URL.createObjectURL(formData.file_daftar_gaji))
            :
            formData.file_daftar_gaji === "" ?
                setSrcDaftarGaji(base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + decryptedUser.id_opd + '/' + pencairan.jenis + '/daftar_gaji/' + pencairan.file)
                :
                setSrcDaftarGaji(URL.createObjectURL(formData.file_daftar_gaji))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.file_daftar_gaji])

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    const onChangeInput = (e) => {
        if (e.target.name === "anggaran") {
            formatRupiah(e);
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value
            })
        }
        console.log(formData);
    }

    const formatRupiah = (e) => {
        const nominal = e.target.value;
        const nominalz = nominal.replace(/\./g, '')
        const price = new Intl.NumberFormat('id-ID').format(nominalz);
        setFormData({
            ...formData,
            [e.target.name]: price
        })
    }

    const loadData = event => {
        const file = event.target.files[0];
        console.log(file);
        console.log(event);
        if (file === undefined || file === "") {
            setFormData({
                ...formData,
                [event.target.name]: ""
            })
        }
        else {
            setFormData({
                ...formData,
                [event.target.name]: file
            })
        }
        console.log(formData);
    }

    const submitForm = () => {
        const isValid = checkForm(formData);
        if (!isValid) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Isi semua Input'
            })
            return;
        }

        setLoading(true);
        axios.post(
            base_url + '/bnd/pencairan/insert_ls_bj',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })

                const fbData = {
                    anggaran : formData.anggaran,
                    jenis : formData.jenis,
                    jenis_ls : formData.jenis_ls,
                    id_opd : decryptedUser.id_opd,
                    nm_opd : decryptedUser.nm_opd
                }

                updateFirebasePermintaan(fbData, 0)

                navigate(-1);
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setLoading(false)
            })
    }

    const updateData = () => {
        console.log(formData);
        setLoading(true);
        axios.post(
            base_url + '/bnd/pencairan/update_ls_bj',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })

                const fbData = {
                    anggaran : formData.anggaran,
                    jenis : formData.jenis,
                    jenis_ls : formData.jenis_ls,
                    id_opd : decryptedUser.id_opd,
                    nm_opd : decryptedUser.nm_opd
                }

                updateFirebasePermintaan(fbData, 1)
                navigate(-1);
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setLoading(false)
            })
    }

    function checkForm(obj) {
        for (var key in obj) {
            if (obj[key] === "") {
                console.log("Check Form Salah " + [key]);
                return false;
            }
        }
        console.log("Check Form Benar");
        return true;
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            {formData.revisi === null ? "" :
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography color={"error"}>Note : {formData.revisi}</Typography>
                    </Grid>
                </Grid>
            }
            <Grid container spacing={4}>
                <Grid item xs={12} md={3}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            disableFuture
                            label="Tanggal SPM"
                            openTo="day"
                            inputFormat="yyyy-MM-dd"
                            value={formData.tgl_spm}
                            onChange={(newValue) => {
                                setFormData({
                                    ...formData,
                                    tgl_spm: format(new Date(newValue), "yyyy-MM-dd")
                                })
                                console.log(formData);
                            }}
                            renderInput={(params) => <TextField {...params} fullWidth variant="standard" sx={{ mt: 2 }} />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={3} sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        name='no_spm'
                        id="standard-basic"
                        label="Nomor SPM"
                        variant="standard"
                        margin="normal"
                        value={formData.no_spm}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.no_spm === "" ? true : false}
                        inputProps={{
                            readOnly: (pencairan !== null)
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={3} sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        name='no_spp'
                        id="standard-basic"
                        label="Nomor SPP"
                        variant="standard"
                        margin="normal"
                        value={formData.no_spp}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.no_spp === "" ? true : false}
                    />
                </Grid>
                <Grid item xs={12} md={3} sx={{ textAlign: "center" }}>
                    <FormControl fullWidth sx={{ my: 2 }} variant="standard">
                        <InputLabel htmlFor="standard-adornment-amount">Nilai Kotor</InputLabel>
                        <Input
                            id="standard-adornment-amount"
                            value={formData.anggaran || ''}
                            onChange={onChangeInput}
                            startAdornment={<InputAdornment position="start">Rp</InputAdornment>}
                            name="anggaran"
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            error={formData.anggaran === "" || formData.anggaran === "0" ? true : false}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        multiline
                        fullWidth
                        name='keperluan'
                        id="standard-basic"
                        label="Keperluan"
                        variant="standard"
                        margin="normal"
                        rows={4}
                        value={formData.keperluan}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.keperluan === "" ? true : false}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} py={2} justifyContent="center">
                <Grid item xs={"auto"}>
                    <Button
                        variant="outlined"
                        component="label"
                        startIcon={<AttachFile />}
                        color={
                            pencairan === null ?
                                formData.file_spm === "" ? "error" : "primary"
                                :
                                "primary"
                        }
                    >
                        File SPM dll
                        <input
                            hidden
                            name='file_spm'
                            accept="application/pdf"
                            multiple type="file"
                            onChange={loadData}
                        />
                    </Button>
                </Grid>
            </Grid>
            {src === "" ?
                "" :
                <Grid container spacing={2} py={2} justifyContent="center">
                    <Grid item xs={10} sx={{ textAlign: "center" }}>
                        <Accordion>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                <Typography>File SPM</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <iframe width='100%' height={700} title="Pdf" src={src} />
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
            }
            <Grid container spacing={2} py={2} justifyContent="center">
                <Grid item xs={"auto"}>
                    <Button
                        variant="outlined"
                        component="label"
                        startIcon={<AttachFile />}
                        color={
                            pencairan === null ?
                                formData.file_daftar_gaji === "" ? "error" : "primary"
                                :
                                "primary"
                        }
                    >
                        File Daftar Gaji
                        <input
                            hidden
                            name='file_daftar_gaji'
                            accept="application/pdf"
                            multiple type="file"
                            onChange={loadData}
                        />
                    </Button>
                </Grid>
            </Grid>
            {srcDaftarGaji === "" ?
                "" :
                <Grid container spacing={2} py={2} justifyContent="center">
                    <Grid item xs={10} sx={{ textAlign: "center" }}>
                        <Accordion>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                <Typography>File</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <iframe width='100%' height={700} title="Pdf" src={srcDaftarGaji} />
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
            }
            <Grid container spacing={2} py={2} justifyContent="flex-end">
                <Grid item >
                    <LoadingButton
                        onClick={pencairan === null ? submitForm : updateData}
                        loading={loading}
                        variant="contained"
                        margin="normal"
                        loadingPosition="start"
                        startIcon={<Save />}
                    >
                        {pencairan === null ? "Simpan" : "Update"}
                    </LoadingButton>
                </Grid>
            </Grid>
        </Box>
    )
}

export default FormGaji